import moment from "moment";

const NO_DATE = Number.MAX_SAFE_INTEGER;

const expenseDateOf = (row) =>
  row?.expense_date || row?.finance?.expired_at || row?.created_at;

const timeOf = (row) => {
  const date = expenseDateOf(row);

  if (!date) return NO_DATE;

  const parsed = moment(date);

  return parsed.isValid() ? parsed.valueOf() : NO_DATE;
};

export const sortByExpenseDate = (rows) =>
  Array.isArray(rows)
    ? rows
        .map((row, index) => ({ row, index, time: timeOf(row) }))
        .sort((a, b) => a.time - b.time || a.index - b.index)
        .map(({ row }) => row)
    : [];
